import React, { useState } from 'react';
import Page from '../components/Layout/Page';
import api from '../services/api';

const CONTACT_EMAIL = 'contact@zenkart.fr';

// Doit rester aligné sur SUBJECTS dans backend/app/routers/contact.py :
// le backend rejette toute autre valeur.
const SUBJECTS = [
  { value: 'compte',      label: 'Mon compte' },
  { value: 'garage',      label: 'Garage / professionnel' },
  { value: 'partenariat', label: 'Partenariat créateur' },
  { value: 'technique',   label: 'Problème technique' },
  { value: 'autre',       label: 'Autre' },
];

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', subject: 'compte', message: '', website: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSending(true);
    try {
      // Chemin complet obligatoire : l'instance axios a pour baseURL la racine
      // du site, donc '/contact' tapait la SPA (405) au lieu de l'API.
      await api.post('/api/contact', form);
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || `L'envoi a échoué. Écrivez-nous directement à ${CONTACT_EMAIL}.`);
    } finally {
      setSending(false);
    }
  };

  return (
    <Page
      largeur="etroite"
      titre="Contact"
      chapeau="Une question sur une affaire, votre compte, un partenariat ou un souci technique ? Nous répondons sous 48 h ouvrées."
    >
      <p className="zk-carte">
        Par email : <a href={`mailto:${CONTACT_EMAIL}`} className="zk-lien">{CONTACT_EMAIL}</a>
      </p>

      {sent ? (
        <div role="status" className="zk-alerte ok" style={{ marginTop: 18 }}>
          <b>Message envoyé.</b> Nous vous répondrons sous 48 h ouvrées à l’adresse <b>{form.email}</b>.
        </div>
      ) : (
        <form onSubmit={submit} noValidate style={{ marginTop: 18 }}>
          <div className="zk-champ">
            <label htmlFor="contact-nom">Nom</label>
            <input id="contact-nom" type="text" required minLength={2} maxLength={100}
              value={form.name} onChange={set('name')} placeholder="Votre nom" />
          </div>
          <div className="zk-champ">
            <label htmlFor="contact-email">Email</label>
            <input id="contact-email" type="email" required value={form.email} onChange={set('email')} placeholder="vous@exemple.fr" />
          </div>
          <div className="zk-champ">
            <label htmlFor="contact-sujet">Sujet</label>
            <select id="contact-sujet" value={form.subject} onChange={set('subject')}>
              {SUBJECTS.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
            </select>
          </div>
          <div className="zk-champ">
            <label htmlFor="contact-message">Message</label>
            <textarea id="contact-message" required minLength={10} maxLength={5000} rows={7}
              value={form.message} onChange={set('message')} placeholder="Décrivez votre demande…" />
            <small>{form.message.length}/5000 caractères</small>
          </div>

          {/* Honeypot : invisible pour un humain, rempli par les bots. */}
          <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, overflow: 'hidden' }}>
            <label htmlFor="website">Ne pas remplir</label>
            <input id="website" name="website" type="text" tabIndex={-1} autoComplete="off" value={form.website} onChange={set('website')} />
          </div>

          {error && <div role="alert" className="zk-alerte erreur" style={{ marginBottom: 16 }}>{error}</div>}

          <button type="submit" className="zk-bouton plein" disabled={sending}>
            {sending ? 'Envoi en cours…' : 'Envoyer le message'}
          </button>
          <p style={{ fontSize: 'var(--zk-type-petit)', color: 'var(--zk-muted)', marginTop: 14 }}>
            Votre adresse email n’est utilisée que pour vous répondre. Voir notre{' '}
            <a href="/confidentialite" className="zk-lien">politique de confidentialité</a>.
          </p>
        </form>
      )}
    </Page>
  );
}
